module.exports = __webpack_public_path__ + "img/best_price_offer.3a5144c1.svg";